import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Modal } from 'react-bootstrap'
import "antd/dist/antd.min.css";
import './index.scss';
import { useTranslation } from 'react-i18next'
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import CheckoutForm from "./Checkout";
import { useSelector, useDispatch } from "react-redux";
import { useGetUserDataQuery } from '../../services/login';
import { useGetAllPaymentsQuery, useCheckoutMutation, useGuestCheckoutMutation } from '../../services/payments';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IconButton from '@mui/material/IconButton';
import Host from '../../Components/Host';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import { addCheckoutMethod, addGuestShippment, addGuestPayment } from "../../Reducers/authReducer";
import { useFetchQuery } from '../../services/cart';
import Countries from '../../Components/Header/Countries';
import 'react-phone-number-input/style.css'
import Button from '@mui/joy/Button';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Loader from '../../Components/Loader';
import HelmetComponent from '../../Components/HelmetComponent';
import PurchaseItems from '../../Components/PrchaseItems';
import CardsSVGs from '../../Components/CardsSVGs';
import SearchLoader from '../../Components/SearchLoader';
import CircularProgress from '@mui/material/CircularProgress';
// import ApplePayCheckout from '../../Components/ApplePayCheckout';
import formatPrice from '../../Components/formatPrice';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

function PurchaseGuest() {
  const { userId, userToken, userEmail, userName, languageCode, countryCode, cartToken, guestShippment, guestPayment } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const findCountry = Countries?.find((l) => l.code === countryCode)
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const responseInfo = useGetAllPaymentsQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const paymentData = responseInfo?.data?.result?.data
  const getdefaultPayment = paymentData?.find((l) => l.id === responseInfo?.data?.customer?.invoice_settings?.default_payment_method)
  const { data: userData } = useGetUserDataQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const couponCode = new URLSearchParams(location.search).get('coupon') || null
  const [getCoupon, setCoupon] = useState('')
  const { data: cartInfo, isLoading, isFetching, refetch } = useFetchQuery({ coupon: couponCode, userId: userId, cartToken: cartToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const cartData = cartInfo?.cart
  const thisToken = cartInfo?.token
  const couponData = cartInfo?.coupon
  const [getPhone, setPhone] = useState('')
  const [getPhoneError, setPhoneError] = useState(false)
  const [createcheckout, checkoutResult] = useGuestCheckoutMutation()

  const [getPaymentModal, setPaymentModal] = React.useState(false);
  function addPaymentMethodModal() {
    setPaymentModal(true)
  }
  function closePaymentModal() {
    setPaymentModal(false)
  }

  useEffect(() => {
    try {
      if (checkoutResult?.data?.success) {
        dispatch(addCheckoutMethod({ isPurchase: cartToken }))
        dispatch(addGuestShippment({ guestShippment: '' }))
        dispatch(addGuestPayment({ guestPayment: '' }))
        refetch()
        let ItemsData = []
        checkoutResult?.data?.items?.map((item) => {
          ItemsData.push({
            item_id: item?.product_id,
            item_name: item?.title,
            price: item?.price,
            quantity: item?.quantity
          })
        })
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: checkoutResult?.data?.order?.id,
            currency: checkoutResult?.data?.order?.currency,
            value: Number(checkoutResult?.data?.order?.value),
            shipping: Number(checkoutResult?.data?.order?.shipping),
            items: ItemsData
          }
        });

        let ItemsDataSuccess = []
        checkoutResult?.data?.items?.map((item) => {
          ItemsDataSuccess.push({
            product_id: item?.product_id,
            title: item?.title,
            conditions: item?.conditions,
            current_variant: item?.current_variant,
            estimated_delivery: item?.estimated_delivery,
            quantity: item?.quantity,
            image: item?.image
          })
        })
        window.PurchaseItems = [];
        window.PurchaseItems.push({
          order_number: checkoutResult?.data?.order_number,
          status: checkoutResult?.data?.status,
          items: ItemsDataSuccess
        });


        history.push(`/purchase/success?order=${checkoutResult?.data?.order_number}&token=${checkoutResult?.data?.token}`)
      } else {
        setLoading(false);
      }
      if (paymentCompleted) {
        setPaymentModal(false)
      }
    } catch (e) {
      setLoading(false);
    }

  }, [checkoutResult, paymentCompleted, getPaymentModal, checkoutResult?.data?.success])

  const [value, setValue] = React.useState(false);
  const TotalPrice = cartData?.reduce((accumulator, value) => {
    const productPrice = value.prices?.value * value.quantity;
    return accumulator + productPrice
  }, 0);

  if ((userId && userToken)) {
    history.push(`/purchase`)
  }

  const [getShippingModal, setShippingModal] = React.useState(false);
  function addShippingModal() {
    setShippingModal(true)
  }
  function closeShippingModal() {
    setShippingModal(false)
  }

  async function createshippingaddress(data) {
    if (isValidPhoneNumber(getPhone)) {
      dispatch(addGuestShippment({
        guestShippment: {
          name: data.name,
          email: data.email,
          address: data.address,
          street: data.street,
          city: data.city,
          country: findCountry?.label,
          country_code: findCountry?.code,
          zip_code: data.zip_code,
          phone: getPhone
        }
      }));
      setShippingModal(false)
    } else {
      setPhoneError(true)
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])

  function proceedDefaultPayment() {
    createcheckout({
      payment_method_id: guestPayment?.pmid,
      shipping_address: guestShippment,
      language: languageCode,
      country: countryCode,
      amount: couponData ? Number(TotalPrice) - Number(couponData?.discount) : Number(TotalPrice),
      shipping: Number(userData?.contant?.standard_delivery),
      currency: cartData?.[0]?.prices?.currency,
      delivery_days: Number(userData?.contant?.delivery_days),
      card_country: getdefaultPayment?.card?.country,
      name: guestPayment?.name,
      email: guestShippment?.email,
      products: cartData,
      cartToken: cartToken,
      domainName: Host?.domainName,
      domain: window.location.hostname || Host?.domain,
      domainEmail: Host?.email,
      userEmail: guestShippment?.email,
      countryCode: countryCode,
      token: thisToken,
      coupon: couponData ? couponData : null,
      guest_checkout: 'guest_checkout'
    })
  }

  const [loadingAuth, setLoadingAuth] = useState(false);

  function buttonDisabled() {
    if (checkoutResult.isLoading) {
      return true
    } else if (loading) {
      return true
    } else if (loadingAuth) {
      return true
    } else if (!guestPayment?.pmid) {
      return true
    } else if (!guestShippment?.name) {
      return true
    } else {
      return false
    }
  }

  const ppbutton = {
    height: '50px',
    background: buttonDisabled() ? '#f0f4f8' : Host?.bgColor,
    color: buttonDisabled() ? '#444' : Host?.buttonColor,
    width: '100%'
  }

  const [isErrorMessage, pErrorMessage] = useState('');
  const CheckoutAuth = ({ clientSecret }) => {
    const stripe = useStripe();
    useEffect(() => {
      setLoadingAuth(true)
      const confirmPayment = async () => {
        try {
          const { error: actionError, paymentIntent: actionPaymentIntent } = await stripe.confirmCardPayment(clientSecret?.client_secret);
          const checkttht = actionError?.type?.split('_')
          if (actionPaymentIntent?.status === 'succeeded') {
            createcheckout({
              payment_method_id: guestPayment?.pmid,
              shipping_address: guestShippment,
              language: languageCode,
              country: countryCode,
              amount: couponData ? Number(TotalPrice) - Number(couponData?.discount) : Number(TotalPrice),
              shipping: Number(userData?.contant?.standard_delivery),
              currency: cartData?.[0]?.prices?.currency,
              delivery_days: Number(userData?.contant?.delivery_days),
              card_country: getdefaultPayment?.card?.country,
              name: guestPayment?.name,
              email: guestShippment?.email,
              products: cartData,
              cartToken: cartToken,
              domainName: Host?.domainName,
              domain: window.location.hostname || Host?.domain,
              domainEmail: Host?.email,
              userEmail: guestShippment?.email,
              countryCode: countryCode,
              token: thisToken,
              coupon: couponData ? couponData : null,
              intent_id: clientSecret?.intent_id,
              auth_success: 'auth_success'
            })
          } else {
            setLoadingAuth(false)
          }
          if (checkttht?.includes('error')) {
            pErrorMessage('Payment rejected. Please use a different card.')
            setLoadingAuth(false)
            createcheckout()
          }
        } catch (error) {
          return;
        }
      };
      if (stripe && clientSecret) {
        setLoadingAuth(true)
        confirmPayment();
      }
    }, [stripe, clientSecret, checkoutResult]);
    return (
      <> </>
    );
  };

  return (
    <>
      {loadingAuth &&
        <div style={{ position: 'absolute', right: 0, left: 0, top: 0, zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#ffffff7d' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '10px', color: '#000' }}>Processing Please Wait!</div>
            <SearchLoader />
            {/* <CircularProgress style={{width: '30px', height: '30px'}} /> */}
          </div>
        </div>
      }
      {!checkoutResult?.data?.success &&
        <>
          {checkoutResult?.data?.client_secret &&
            <Elements stripe={stripePromise}>
              <CheckoutAuth
                clientSecret={checkoutResult?.data}
              />
            </Elements>
          }
        </>
      }

      <HelmetComponent title={'Guest purchase'} />
      <div className="Purchase-page">
        <Modal className="shipping-dialogue" show={getShippingModal} onHide={closeShippingModal} centered animation={false}>
          <Modal.Body>
            <IconButton
              style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px', zIndex: 111 }}
              onClick={closeShippingModal}
            >
              <CloseIcon className="Header-close-modal-icon" />
            </IconButton>
            <div className="row">
              <div className="col-md-12">
                <h5 style={{
                  textAlign: 'center',
                  padding: '10px',
                  fontWeight: 400,
                  fontSize: '1rem'
                }}>Add new shipping address</h5>
              </div>
            </div>
            <form onSubmit={handleSubmit(createshippingaddress)}>
              <div className="row">
                <div className="col-md-5">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('name')} </label>
                    <input
                      defaultValue={guestShippment?.name}
                      type="text"
                      className="form-control"
                      id="name"
                      aria-invalid={errors.name ? "true" : "false"}
                      {...register('name', { required: true })} />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('email')} </label>
                    <input
                      defaultValue={guestShippment?.email}
                      type="text"
                      className="form-control"
                      id="email"
                      aria-invalid={errors.email ? "true" : "false"}
                      {...register('email', { required: true })} />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('address_flat')} </label>
                    <input
                      defaultValue={guestShippment?.address}
                      type="text"
                      className="form-control"
                      id="address"
                      aria-invalid={errors.address ? "true" : "false"}
                      {...register('address', { required: true })} />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('street_area')} </label>
                    <input
                      defaultValue={guestShippment?.name}
                      type="text"
                      className="form-control"
                      id="street"
                      aria-invalid={errors.street ? "true" : "false"}
                      {...register('street', { required: true })} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('city')} </label>
                    <input
                      defaultValue={guestShippment?.city}
                      type="text"
                      className="form-control"
                      id="city"
                      aria-invalid={errors.city ? "true" : "false"}
                      {...register('city', { required: true })} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('country')} </label>
                    <select className="form-control">
                      <option disabled selected>{findCountry?.label}</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('phone')} </label>
                    <PhoneInput
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry={countryCode}
                      value={getPhone}
                      onChange={setPhone}
                    />
                    {getPhoneError &&
                      <>
                        {getPhone && isValidPhoneNumber(getPhone) ? '' :
                          <div><small style={{ color: 'tomato' }}>{'Invalid phone number'}</small></div>
                        }
                      </>
                    }
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontSize: '14px' }}>{t('zip_code')} </label>
                    <input
                      defaultValue={guestShippment?.zip_code}
                      type="number"
                      className="form-control"
                      id="zip_code"
                      aria-invalid={errors.zip_code ? "true" : "false"}
                      {...register('zip_code', { required: false })} />
                  </div>
                </div>
                <div className="col-md-12 Header-signin-button">
                  <div className="form-group">
                    <Button
                      style={{ background: Host?.bgColor, color: Host?.buttonColor, width: '100%', height: '45px' }}
                      type="submit">
                      {t('submit')}
                    </Button>

                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal className="shipping-dialogue" show={getPaymentModal} onHide={closePaymentModal} centered animation={false}>
          <Modal.Body>
            <IconButton
              style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px', zIndex: 111 }}
              onClick={closePaymentModal}
            >
              <CloseIcon className="Header-close-modal-icon" />
            </IconButton>
            <Elements stripe={stripePromise}>
              <CheckoutForm
                setPaymentCompleted={setPaymentCompleted}
                language={languageCode}
                userData={userData}
              />
            </Elements>
          </Modal.Body>
        </Modal>

        <div className="container purchase-container">
          <div className="row purchase-section">
            <div className="col-md-6 p0">
              <div className="purchase-form-card">
                <div style={{ background: '#fcfcfc', padding: '20px', borderRadius: '10px', border: '0.7px solid #00000014' }}>
                  <>
                    <div>
                      <div style={{ paddingBottom: '15px', color: '#030303', fontWeight: 400 }}>
                        {t('select_shipping_address')} <br />
                        {!guestShippment && !guestShippment?.name && <small style={{ color: 'tomato', fontSize: '12px' }}>Add shipping address</small>}
                      </div>
                      <div style={{ marginBottom: '20px', borderBottom: '1px solid #eee', width: '100%', height: '60px', display: 'flex', alignItems: 'center', padding: '0px', justifyContent: 'space-between' }}>
                        <Button
                          variant='outlined'
                          style={{ textTransform: 'capitalize', fontWeight: 400 }}
                          onClick={(() => addShippingModal())}>
                          {guestShippment ? t('change') : t('add')}
                        </Button>
                      </div>
                      {guestShippment && guestShippment?.name &&
                        <>
                          <div className="col-md-12" style={{ marginBottom: '15px', padding: '0px', position: 'relative' }}>
                            <div className="cart-page-card"
                              style={{ border: '1px solid #7ea6ee8c', cursor: 'pointer', padding: '10px', borderRadius: 8, display: 'flex', alignItems: 'center', position: 'relative', background: 'whitesmoke' }}
                            >
                              <RadioGroup value={value} style={{ paddingRight: '10px' }}>
                                <FormControlLabel
                                  style={{ margin: 0 }}
                                  value={true}
                                  control={<Radio checked={guestShippment} />} />
                              </RadioGroup>
                              <div className="cart-page-text">
                                <div style={{ width: '100%' }}>
                                  <div style={{ fontSize: '14px' }}>{guestShippment?.name}, {guestShippment?.address}, {guestShippment?.street}, {guestShippment?.city}, {guestShippment?.country_code}</div>
                                  {/* <div style={{ fontSize: '14px' }}>{guestShippment?.city}, {guestShippment?.country} {guestShippment?.country_code}</div> */}
                                  <div style={{ fontSize: '14px' }}>{guestShippment?.email}, {guestShippment?.phone}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </div>
                    <br />


                    <h6 style={{ paddingBottom: '15px', color: '#030303', fontWeight: 400 }}>
                      {t('select_payment_method')} <br />
                      {!guestPayment && !guestPayment?.pmid && <small style={{ color: 'tomato', fontSize: '12px' }}>Add payment method</small>}
                    </h6>
                    <div>
                      <div style={{ marginBottom: '20px', borderBottom: '1px solid #eee', width: '100%', height: '60px', display: 'flex', alignItems: 'center', padding: '0px', justifyContent: 'space-between' }}>
                        <Button
                          variant='outlined'
                          style={{ border: '1px solid #eee', textTransform: 'capitalize', fontWeight: 400 }}
                          onClick={(() => addPaymentMethodModal())} >
                          {guestPayment && guestPayment?.pmid ? t('change') : t('add')}
                        </Button>
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ margin: '0 5px' }}>
                              <svg width="24px" height="15px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                                <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <g id="New-Icons" transform="translate(-80.000000, -280.000000)" fillRule="nonzero">
                                    <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
                                      <g id="Color" transform="translate(0.000000, 80.000000)">
                                        <g id="Visa" transform="translate(40.000000, 0.000000)">
                                          <rect id="Container" strokeOpacity="0.2" stroke="#000000" strokeWidth="0.5" fill="#FFFFFF" x="0.25" y="0.25" width="23.5" height="15.5" rx="2"></rect>
                                          <path d="M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z" id="Shape" fill="#1434CB"></path>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span style={{ margin: '0 5px' }}>
                              <svg
                                height="15px"
                                viewBox="0 0 24 16"
                                width="24px"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g fill="none" fillRule="evenodd">
                                  <rect fill="#252525" height="16" rx="2" width="24" />
                                  <circle cx="9" cy="8" fill="#eb001b" r="5" />
                                  <circle cx="15" cy="8" fill="#f79e1b" r="5" />
                                  <path
                                    d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
                                    fill="#ff5f00"
                                  />
                                </g>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>

                      <>
                        {/* <div className="row">
                          <div className="col-md-12" style={{ padding: '0px' }}>
                            <Elements stripe={stripePromise}>
                              <ApplePayCheckout
                                setLoadingAuth={setLoadingAuth}
                                pErrorMessage={pErrorMessage}
                                couponCode={couponCode}
                                data={{
                                  domainName: Host?.domainName,
                                  domain: window.location.hostname || Host?.domain,
                                  domainEmail: Host?.email,
                                }} />
                            </Elements>
                          </div>
                        </div> */}
                   
                      </>

                      {guestPayment && guestPayment?.pmid &&
                        <>
                          <div>
                            <div
                              className="select-payment-method"
                              style={{ border: guestPayment?.pmid ? '1px solid #7ea6ee8c' : '1px solid #eee', cursor: 'pointer', padding: '5px', borderRadius: 8, fontSize: '14px' }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <RadioGroup value={value} style={{ paddingRight: '10px' }}>
                                  <FormControlLabel style={{ margin: 0 }} value={true} control={<Radio checked={guestPayment && guestPayment?.pmid} />} />
                                </RadioGroup>
                                <div>
                                  {/* <div style={{ textTransform: 'capitalize' }}>{guestPayment?.brand}</div>
                                  <div>**** **** **** {guestPayment?.last4}</div> */}
                                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {CardsSVGs(guestPayment?.brand)}
                                    <div style={{ margin: '0px 10px' }}>{t('ending_with')} <strong>{guestPayment?.last4}</strong></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  </>
                </div>
              </div>
            </div>

            <div className="col-md-5 pp-padding">
              <div className="row">
                <div className="col-md-12 pp-padding">
                  <div style={{ padding: '20px', background: '#fcfcfc', border: '0.7px solid #00000014', borderRadius: '10px' }}>
                    {checkoutResult?.error?.data?.error &&
                      <div className='alert alert-danger' style={{ textAlign: 'center' }}>
                        {checkoutResult?.error?.data?.error}
                      </div>
                    }
                    {isErrorMessage &&
                      <div className='alert alert-danger' style={{ textAlign: 'center' }}>
                        {isErrorMessage}
                      </div>
                    }
                    <h6 style={{ paddingBottom: '15px', color: '#030303', fontWeight: 400 }}>{t('your_order')}</h6>

                    {isLoading &&
                      <div style={{ textAlign: 'center', padding: '10px 0px 10px 0px' }}>
                        <CircularProgress style={{ width: '2rem', height: '2rem', color: '#fe7f4a' }} />
                      </div>
                    }


                    {cartData &&
                      <PurchaseItems cartData={cartData} userData={userData} purchaseresult={checkoutResult} />
                    }
                    {cartData?.length > 0 &&
                      <div className='ppbt pp-info-section'>
                        <div className='ppbt' style={{ padding: '15px' }}>
                          <div className='coupon-section' style={{ display: 'flex' }}>
                            <div style={{ width: '100%' }}>
                              <input
                                disabled={couponCode}
                                placeholder={couponCode ? couponCode : 'Coupon'}
                                className='form-control coupon-input'
                                style={{ height: '40px', borderRadius: 0 }}
                                onChange={(e) => setCoupon(e.target.value)}
                              />
                            </div>
                            <Button
                              variant='outlined'
                              disabled={isLoading || isFetching || !couponCode && !getCoupon}
                              style={{ height: '40px', borderRadius: 0, border: 'none' }}
                              className='cp-buttons'
                              onClick={(() =>
                                couponCode ?
                                  history.push(`${window.location.pathname}`) :
                                  history.push(`${window.location.pathname}?coupon=${getCoupon}`)
                              )}
                            >
                              {isLoading || isFetching ?
                                <Loader /> :
                                couponCode ? 'Remove' : 'Apply'
                              }
                            </Button>
                          </div>
                          {couponData &&
                            <>
                              {couponData?.success && <small style={{ color: 'green' }}> {couponData?.success}</small>}
                              {couponData?.error && <small style={{ color: 'tomato' }}> {couponData?.error}</small>}
                            </>
                          }
                          <br />
                          <div style={{ padding: '5px 0px 5px 0px' }}></div>
                          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                            <div><small>{t('sub_total')}</small></div>
                            <div>
                              <small>{formatPrice(TotalPrice, cartData?.[0]?.prices?.currency, 0)}</small>
                            </div>
                          </div>
                          {couponData?.success &&
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                              <div><small>{t('discount')}</small></div>
                              <div>
                                <small>-{formatPrice(couponData?.discount, cartData?.[0]?.prices?.currency, 0)}</small>
                              </div>
                            </div>
                          }
                          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                            <div><small>{t('delivery')} {t('fee')}</small></div>
                            <div>
                              <small>{userData?.contant?.standard_delivery > 0 ?
                                formatPrice(0, userData?.contant?.currency, userData?.contant?.standard_delivery) :
                                t('free')}</small>
                            </div>
                          </div>
                          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                            <div><small><strong>{t('total')}</strong> {t('inclusive')} {`(of VAT)`}</small></div>
                            <div>
                              {formatPrice(couponData ? Number(TotalPrice) - Number(couponData?.discount) : TotalPrice, cartData?.[0]?.prices?.currency, userData?.contant?.standard_delivery)}
                            </div>
                          </div>
                        </div>
                        <div className='purchase-button-bottom'>
                          <Button
                            style={ppbutton}
                            disabled={(buttonDisabled())}
                            onClick={() => proceedDefaultPayment()}
                          >
                            {checkoutResult?.isLoading ?
                              <div className="spinner-border spinner-border-sm text-dark" style={{ fontSize: '7px' }} role="status"></div>
                              :
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                  <span>{t('place_order')}&nbsp; </span>
                                  <span><ArrowForwardIcon style={{ fontSize: '1.2rem' }} /></span>
                                </span>
                                {formatPrice(couponData ? Number(TotalPrice) - Number(couponData?.discount) : TotalPrice, cartData?.[0]?.prices?.currency, userData?.contant?.standard_delivery)}
                              </div>
                            }
                          </Button>
                        </div>
                      </div>
                    }
                    <br />
                    <div><small style={{ fontSize: '12px' }}><strong>Security and Privacy</strong></small></div>
                    <div style={{ lineHeight: 1 }}><small style={{ fontSize: '12px', lineHeight: 1 }}>Our checkout is safe and secure. We do not store any payment card information on our systems</small></div>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Link style={{ fontSize: '12px', margin: '0 5px' }} to="/privacy-policy">{t('privacy_policy')}</Link>
                      <Link style={{ fontSize: '12px', margin: '0 5px' }} to="/terms-and-conditions">{t('terms_and_conditions')}</Link>
                    </div>
                    <div style={{ textAlign: 'center' }}><small style={{ fontSize: '12px' }}>© 2024 {Host?.domainName}. All Rights Reserved</small></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </>
  );
}

export default PurchaseGuest;
